import React from 'react';

const CodeBlock = ({ code, language = 'python', title = '', showLineNumbers = true }) => {
  // Simple syntax highlighting
  const highlightCode = (code) => {
    let highlighted = code;
    
    // Keywords
    const pythonKeywords = ['def', 'class', 'import', 'from', 'return', 'if', 'else', 'elif', 'for', 'while', 'in', 'not', 'and', 'or', 'True', 'False', 'None', 'self', 'with', 'as', 'try', 'except', 'finally', 'raise', 'async', 'await', 'lambda', 'yield', 'pass', 'break', 'continue'];
    
    // Escape HTML first
    highlighted = highlighted
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    
    // Comments
    highlighted = highlighted.replace(/(#.*)$/gm, '<span class="text-muted-foreground/70 italic">$1</span>');
    highlighted = highlighted.replace(/(""".+?""")/gs, '<span class="text-muted-foreground/70 italic">$1</span>');
    
    // Strings
    highlighted = highlighted.replace(/("[^"]*"|'[^']*')/g, '<span class="text-accent">$1</span>');
    highlighted = highlighted.replace(/(f"[^"]*")/g, '<span class="text-accent">$1</span>');
    
    // Keywords
    pythonKeywords.forEach(keyword => {
      const regex = new RegExp(`\\b(${keyword})\\b`, 'g');
      highlighted = highlighted.replace(regex, '<span class="text-secondary font-medium">$1</span>');
    });
    
    // Functions
    highlighted = highlighted.replace(/\b([a-zA-Z_][a-zA-Z0-9_]*)\s*\(/g, '<span class="text-primary">$1</span>(');
    
    // Numbers
    highlighted = highlighted.replace(/\b(\d+\.?\d*)\b/g, '<span class="text-chart-4">$1</span>');
    
    // Class names (capitalized words)
    highlighted = highlighted.replace(/\b([A-Z][a-zA-Z0-9_]*)\b/g, '<span class="text-chart-5">$1</span>');
    
    return highlighted;
  };

  const lines = code.trim().split('\n');

  return (
    <div className="code-block my-4 max-w-full overflow-hidden">
      {title && (
        <div className="code-header">
          <div className="code-dot bg-destructive" />
          <div className="code-dot bg-chart-4" />
          <div className="code-dot bg-accent" />
          <span className="ml-3 text-xs text-muted-foreground font-mono">{title}</span>
        </div>
      )}
      <div className="code-content overflow-x-auto">
        <pre className="font-mono text-xs md:text-sm leading-relaxed">
          {lines.map((line, index) => (
            <div key={index} className="flex">
              {showLineNumbers && (
                <span className="select-none text-muted-foreground/50 w-8 flex-shrink-0 text-right pr-4">
                  {index + 1}
                </span>
              )}
              <code 
                dangerouslySetInnerHTML={{ __html: highlightCode(line) || '&nbsp;' }}
                className="flex-1"
              />
            </div>
          ))}
        </pre>
      </div>
    </div>
  );
};

export default CodeBlock;
